import React, { createContext, useState, useContext, useEffect } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Check localStorage so the user's preference is saved
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme === "dark" : true; // Default to dark
  });

  // Define the two color palettes with tenant-aware fallback options
  const colors = {
    brand: "#6D9BC3",
    brandDark: "#0f172a",
    success: "#10b981",
    danger: "#ef4444",
    star: "#f5a623",
    // Dynamic colors based on mode
    bg: isDarkMode ? "#020617" : "#F8FAFC",
    card: isDarkMode ? "#1e293b" : "#FFFFFF",
    text: isDarkMode ? "#f8fafc" : "#0F172A",
    muted: isDarkMode ? "#94a3b8" : "#64748B",
    border: isDarkMode ? "rgba(255,255,255,0.1)" : "#E2E8F0",
    navBg: isDarkMode ? "#0a1120" : "#FFFFFF",
    navOverlay: isDarkMode ? "rgba(10, 23, 42, 0.82)" : "rgba(255, 255, 255, 0.1)"
  };

  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
  };

  // Update localStorage whenever theme changes
  useEffect(() => {
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme easily in any file
export const useTheme = () => useContext(ThemeContext);